import { useTheme } from '@mui/material/styles';
import { FONTS } from '../../config/app-config';
import React, { useEffect, useMemo } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function GlossaryDialog({ open, onClose, contentHtml, title }) {
    const theme = useTheme();
    // lock background scroll when open
    useEffect(() => {
        document.body.style.overflow = open ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [open]);

    // strip out any elements with class="panel-heading"
    const sanitizedHtml = useMemo(() => {
        if (!contentHtml) return '';
        const parser = new DOMParser();
        const doc = parser.parseFromString(contentHtml, 'text/html');
        doc.querySelectorAll('.panel-heading').forEach(el => el.remove());
        return doc.body.innerHTML;
    }, [contentHtml]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            scroll="paper"
        >
            <DialogTitle variant="h6" sx={{ m: 0, p: 2, pl: 4, backgroundColor: theme.palette.primary.main, color: 'white', fontFamily: FONTS.heading }}>
                {`${title} | Glossary`}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'inherit'
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <div
                    dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
                />
            </DialogContent>
        </Dialog>
    );
}

